import { Injectable, Inject } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { VolunteerOpportunity } from "../models/volunteer-registration.model";
import { VolunteerRegistration } from "../models/volunteer.model";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { VolunteerActivityShift } from "../models/shift.model";
import { VolunteerEventDetailVM, VolunteerOpportunityVM } from "../models/volunteer-opportunity.model";
import { VolunteerSlot } from "../models/volunteer-slot.model";
import { VolunteerCalendar } from "../models/volunteer-calendar.model";
import { LastQuestionAnswer } from "../models/volunteer-last-question-answer.model";

@Injectable({
  providedIn: "root",
})
export class VolunteerService {
  constructor(
    private http: HttpClient,
    @Inject("BASE_URL") private baseUrl: string
  ) {}

  getVolunteerDetails(corpId: string, eventId: number) {
    return this.http.get<VolunteerOpportunityVM>(
      this.baseUrl +
        "api/volunteer/volunteeroppregistration/" +
        corpId +
        "/" +
        eventId
    );
  }

  getVolunteerEvents(corpId: string) {
    return this.http.get<VolunteerEventDetailVM[]>(
      this.baseUrl + "api/volunteer/events/" + corpId
    );
  }

  getVolunteerEventDetails(corpId: string) {
    return this.http.get<VolunteerCalendar[]>(
      this.baseUrl + "api/volunteer/volunteereventdetails/" + corpId
    );
  }

  saveVolunteerRegistration(saveEntryData: VolunteerSlot[]) {
    return this.http.post<VolunteerSlot[]>(
      this.baseUrl + "api/volunteer/saveVolunteerRegistration",
      saveEntryData
    );
  }

  getActivityShifts(activityId: number) {
    return this.http.get<VolunteerActivityShift[]>(
      this.baseUrl + "api/volunteer/activityShiftsGet/" + activityId
    );
  }

  getLastVolunteerQuestionAnswer(corpId: string, questionIds: string) {
    return this.http.get<LastQuestionAnswer[]>(
      this.baseUrl + "api/volunteer/lastquestionanswer/" + corpId + "/" + questionIds
    );
  }
}
